@if(data$ | async; as data){
<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ data.title | translate }}
  </h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  ></button>
</div>
<div class="">
  <ng-container *ngComponentOutlet="data.component ?? null; injector: injector">
  </ng-container>
</div>
}
